import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

type TextTestimonial = {
    type: "text";
    author: string;
    source: string;
    link: string;
    content: string[];
};

type ImageTestimonial = {
    type: "image";
    imageUrl: string;
    alt: string;
};

type Testimonial = TextTestimonial | ImageTestimonial;

const testimonials: Testimonial[] = [
    {
        type: "image",
        imageUrl: "/card.jpg",
        alt: "Thank-you card from a family"
    },
    {
        type: "image",
        imageUrl: "/card-2.jpg",
        alt: "Thank-you card from a family"
    }
];

function TestimonialCarousel(): JSX.Element {
    const [index, setIndex] = useState<number>(0);

    const next = () => setIndex((index + 1) % testimonials.length);
    const prev = () => setIndex((index - 1 + testimonials.length) % testimonials.length);
    const current = testimonials[index];

    return (
        <section className="w-full py-16" style={{backgroundColor: "#e6f0f8"}}>
            <div className="container mx-auto px-6 md:px-12 text-center relative max-w-3xl">
                {/* Navigation buttons */}
                <button
                    onClick={prev}
                    className="absolute left-0 top-1/2 transform -translate-y-1/2 p-2 text-cadetblue hover:text-blue-700"
                    style={{ color: "#5F9EA0" }}
                    aria-label="Previous"
                >
                    <ChevronLeft size={32} />
                </button>
                <button
                    onClick={next}
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 p-2 text-cadetblue hover:text-blue-700"
                    style={{ color: "#5F9EA0" }}
                    aria-label="Next"
                >
                    <ChevronRight size={32} />
                </button>

                {/* Testimonial Content */}
                <div className="transition-all duration-300 ease-in-out">
                    {current.type === "text" ? (
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                className="inline-block w-8 h-8 text-gray-400 mb-6"
                                viewBox="0 0 975.036 975.036"
                            >
                                <path d="M925.036 57.197h-304c-27.6..." />
                            </svg>
                            <div className="space-y-4 mb-6">
                                {current.content.map((paragraph, i) => (
                                    <p key={i} className="leading-relaxed text-lg text-gray-700">{paragraph}</p>
                                ))}
                            </div>
                            <span className="inline-block h-1 w-10 rounded mb-4" style={{ backgroundColor: "#5F9EA0" }}></span>
                            <h2 className="text-gray-900 font-medium title-font tracking-wider text-sm">
                                {current.author}
                            </h2>
                            <p className="text-gray-500 text-sm">
                                <a href={current.link} target="_blank" rel="noopener noreferrer">{current.source}</a>
                            </p>
                        </div>
                    ) : (
                        <img
                            src={current.imageUrl}
                            alt={current.alt}
                            className="mx-auto rounded-lg shadow-lg w-full max-w-[500px] max-h-[800px] object-contain"
                        />
                    )}
                </div>
            </div>
        </section>
    );
}

export default TestimonialCarousel;
